<template>
    <div class="app-container py-4">
        <div
            v-if="isUserLoggedIn"
            class="profile-favorites profile-inner-page px-0 px-sm-4"
        >
            <v-row class="mx-0">
                <v-col cols="12" md="4" class="hidden-sm-and-down pr-4">
                    <profile-menu @logout="logout" :active-link="3"></profile-menu>
                </v-col>
                <v-col cols="12" md="8">
                    <div>
                        <h1>{{ $t('favorites') }}</h1>
                        <div class="pa-md-5">
                            <product-list-skeleton v-if="listLoading" :items-count="8"></product-list-skeleton>
                            <product-list v-else-if="products.length"
                                          :products="products"
                                          :total="total"
                                          :init-page="page"
                                          :last-page="lastPage"
                                          :is-visible-more-button="loadMore"
                                          @snack-bar="snackBar"
                                          @show-more="incrementPage"
                                          @change-page="setPage"
                            ></product-list>
                            <div v-if="isNoProducts" class="d-flex flex-column align-center">
                                <div class="text-center pb-6">{{$t('noProducts')}}</div>
                                <div
                                        class="d-flex flex-column align-center"
                                        v-for="item in $store.getters.categories"
                                        :key="item.id"
                                >
                                    <v-btn
                                            depressed
                                            class="body-1 px-10 main--yellow test-white caption mb-4"
                                            :to="item.url"
                                            outlined
                                            width="200"
                                    >{{ item.localName }}</v-btn>
                                </div>
                            </div>

                            <v-snackbar
                                top
                                v-model="snackOpen"
                            >
                                {{ $t('productFavoritesDelete') }}

                                <template>
                                    <v-btn
                                        class="text--main-yellow text-uppercase"
                                        text
                                        @click="actionFavorites"
                                    >
                                        {{$t('return')}}
                                    </v-btn>
                                    <v-btn text icon @click="closeSnack">
                                        <v-icon color="grey">close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import FavoritesService from '../../../app-front/services/api/FavoitesService';
    import ProductList from '../../../app-front/components/product/product-list';
    import ProductListSkeleton from '../../../app-front/components/skeletons/ProfileProductListSkeleton';
    import ProfileMenu from '../../../app-front/components/profile/menu';
    import RouteAccess from '../../../app-front/mixins/RouteAccess';
    import WatchLogoutRedirect from '../../../app-front/mixins/WatchLogoutRedirect';
    import AppSnack from "../../../general/mixins/AppSnack";
    import Favorites from "../../../app-front/mixins/Favorites";
    import ProductsPagination from '../../../app-front/mixins/ProductsPagination';

    import '../../../../sass/app-front/profile.scss';

    export default {
        name: "ProfileFavorites",
        components: {
            ProductList,
            ProductListSkeleton,
            ProfileMenu,
        },
        mixins: [
            RouteAccess,
            WatchLogoutRedirect,
            AppSnack,
            Favorites,
            ProductsPagination
        ],
        data() {
            return {
                isDataReceived: true,
                metaUrl: '/profile/favorites',
                selectAll: false,
                selectedItem: null,
                selectedItems: {},
                productId: 0,
                categoryItems: [],
            }
        },
        computed: {
            favoritesStoreCount() {
                return this.$store.state.favorites.items.length;
            },
            isNoProducts() {
                return !this.loadMore && !this.products.length && !this.listLoading;
            },
        },
        methods: {
            actionFavorites() {
                this.addFavorite(this.productId);
            },
            authSuccessRouteHandle() {
                this.setProducts();
            },
            logout() {
                this.initLogout();
            },
            setProducts() {
                if (this.listLoading) {
                    return;
                }

                this.listLoading = true;
                FavoritesService.setLocale(this.$store.state.language.appLanguage);
                FavoritesService.getProfileList(this.filters, this.page)
                    .then(res => {
                        const {total, last_page, data} = res.data;
                        this.total = parseInt(total);
                        this.lastPage = parseInt(last_page);
                        this.products.push(...data);
                        this.listLoading = false;
                        this.selectAll = false;
                        this.selectedItems = {};
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            snackBar(id) {
                this.productId = id;
                this.openSnack();
            }
        },
        watch: {
            favoritesStoreCount() {
                if (this.isLoading) return false;

                this.updateProducts();
            }
        }
    }
</script>

<style scoped>

</style>
